import { ConfigType } from 'src/types/commonTypes';

export const UiTheme = {
  hpsmart: 'hpsmart',
  hpx: 'hpx'
};

export const DefaultPreferences: ConfigType = {
  apiKey: 'bltcad87795ce18c6ce',
  accessToken: 'cs8e7a3b88dc78dbe7eb302cbe',
  environment: 'dev',
  apis: {
    'printer-listing-pages':
      'https://www.hpsmartdev.com/content/v3/content_types/printer_listing_pages/entries'
  }
};

export const DOMAIN_PROD = {
  CH: 'https://www.hp-smart.cn',
  DEFAULT: 'https://www.hpsmart.com'
};

export const PORTAL_ORIGIN = {
  PROD_CH: 'https://portal.hp-smart.cn',
  PROD_DEFAULT: 'https://portal.hpsmart.com'
};
